<div *ngIf="languaje === 'en'">
    <li class="pill"  [ngClass]="{'active': is_active}" (click)="showContent()">
        <a class="icon-money">Best Price Gurantee</a>
    </li>
    
    <a class="icon-money pill-mobile" [ngClass]="{'active': show_mobile}" (click)="showMobileContent()">Best Price Gurantee</a>
    <div class="tab-pane active" *ngIf="show_content || show_mobile" [ngClass]="{'show': show_mobile}">
    
        <h2 class="titulo-intro" (click)="toggleClass('1')" [ngClass]="{'open': show_description1}">BEST PRICE GUARANTEE</h2>
    
        <div class="container" [ngClass]="{'show': show_description1}">
            <p><strong>Miles</strong> members will enjoy Best-Price Guarantee when booking travel based on the agreements with <strong>Miles</strong> travel service providers.</p>
            <ul class="number">
               <li><p><strong>Price Guarantee for Air flight.</strong></p>
                In the event of a lower rate available in <strong>Miles</strong> or on another country-based website within 24 hours of booking with <strong>Miles</strong>, <strong>Miles</strong> will credit or refund the difference in price.
               </li> 
               <li><p><strong>Price Guarantee for Hotels.</strong></p>
                In the event of a lower rate available in <strong>Miles</strong> or on another country-based website up to 11:59 pm Pacific, 48 hours after completing the hotel booking, <strong>Miles</strong> will credit or refund the difference in price.
               </li>
            </ul>
            <p><strong>BEST-PRICE GUARANTEE RULES &amp; CONDITIONS</strong></p>
            <p>The trip must be completed as per booked itinerary through Miles to be eligible for
            refund or credit.:</p>
            <p>Member must file a Price Guarantee application form through the app within twenty-four
            (24) hours after the My Rewards booking OR, for hotels, within forty-eight-(48) hours
            after completing the booking. The lower rate must be available for booking at the time of
            contact.</p>
            <p>Each credit is valid for one (1) year from month of issuance.</p>
            <p>Price Guarantee is available only for exact itinerary matches.</p>
            <p>Price Guarantee applies only to prices both advertised and available to the general
            public on an English and Spanish language website. For example, it does not apply to
            rates offered on:</p>
            <ul class="number">
                <li>Membership program websites, corporate discounts or rates</li>
                <li>Group, charter, rewards program, incentive, meeting, convention, consolidator or
                interline prices</li> 
                <li>Prices obtained via auction or similar process</li>
                <li>Prices available only by using a coupon or other promotion not offered to the
                general public.</li>  
            </ul>
            <p>The lower rate may not come from a website where Member called to get the rate, or
            from an e-mail received. Additionally, the rate must be quoted, booked, and paid for in
            US dollars.</p>
            <p>All Price Guarantee requests, including receipts, are subject to verification by the
            Program Administrator. Program Administrator will not accept screenshots or other
            purported evidence of a lower price that cannot be independently confirmed by program
            personnel.</p>
                
        </div>
    </div>
    
    
    
</div>




<!---------------- START SECTION ESPAÑOL --------------------->
<!---------------- START SECTION ESPAÑOL --------------------->



<div *ngIf="languaje === 'es'">

    <li class="pill"  [ngClass]="{'active': is_active}" (click)="showContent()">
        <a class="icon-money">Garantía Mejor Precio</a>
    </li>
    
    <a class="icon-money pill-mobile" [ngClass]="{'active': show_mobile}" (click)="showMobileContent()">Garantía Mejor Precio</a>
    <div class="tab-pane active" *ngIf="show_content || show_mobile" [ngClass]="{'show': show_mobile}">
    
        <h2 class="titulo-intro" (click)="toggleClass('1')" [ngClass]="{'open': show_description1}">GARANTÍA MEJOR PRECIO</h2>
    
        <div class="container" [ngClass]="{'show': show_description1}">
    
            <p>Los miembros de <strong>Miles</strong> disfrutar&aacute;n de la Garant&iacute;a del mejor precio cuando reserven viajes seg&uacute;n los acuerdos con los proveedores de servicios de viajes de <strong>Miles</strong>.</p>
    <ul class="number">
    <li><strong>Garant&iacute;a de precio para vuelo a&eacute;reo</strong></li>
    
    <p>En el caso de que haya una tarifa m&aacute;s baja disponible en <strong>Miles</strong> o en otro sitio web de un pa&iacute;s dentro de las 24 horas posteriores a la reserva con <strong>Miles</strong>, <strong>Miles</strong> acreditar&aacute; o reembolsar&aacute; la diferencia en el precio.</p>
    
    <li><strong>Garant&iacute;a de precio para hoteles</strong></li>
    
    <p>En el caso de que haya una tarifa m&aacute;s baja disponible en <strong>Miles</strong> o en otro sitio web de pa&iacute;s hasta las 11:59 pm hora del Pac&iacute;fico, 48 horas despu&eacute;s de completar la reserva del hotel, <strong>Miles</strong> acreditar&aacute; o reembolsar&aacute; la diferencia en el precio.</p>
    </ul>
    
    <p><strong>REGLAS Y CONDICIONES GARANT&Iacute;A MEJOR PRECIO</strong></p>
    
    <p>El viaje debe completarse seg&uacute;n el itinerario reservado a trav&eacute;s de <strong>Miles</strong> para ser elegible para reembolso o cr&eacute;dito.</p>
    <p>El miembro debe presentar un formulario de solicitud de Garant&iacute;a de precio a trav&eacute;s de la aplicaci&oacute;n m&oacute;vil dentro de las veinticuatro (24) horas posteriores a la reservaci&oacute;n con My Rewards, para hoteles, dentro de las cuarenta y ocho (48) horas posteriores a la finalizaci&oacute;n de la reserva. La tarifa m&aacute;s baja debe estar disponible para la reserva en el momento del contacto.</p>
    <p>Cada cr&eacute;dito es v&aacute;lido por un (1) a&ntilde;o a partir del mes de emisi&oacute;n.</p>
    <p>El precio garantizado est&aacute; disponible solo para coincidencias de itinerario exactas.</p>
    <p>La Garant&iacute;a de precio se aplica solo a los precios anunciados y disponibles para el p&uacute;blico en general en un sitio web en ingl&eacute;s y espa&ntilde;ol. Por ejemplo, no se aplica a las tarifas ofrecidas en:</p>
    <p></p>
    <ul class="number">
    <li>Sitios web del programa de membres&iacute;a, descuentos corporativos o tarifas.</li>
    <li>Precios de grupo, charter, recompensas, incentivos, reuniones, convenciones, consolidadores o interl&iacute;nea.</li>
    <li>Precios obtenidos mediante subasta o proceso similar.</li>
    <li>Precios disponibles solo mediante el uso de un cup&oacute;n u otra promoci&oacute;n no ofrecida al p&uacute;blico en general. </li>
    </ul>
    <p></p>
    <p>La tarifa m&aacute;s baja no puede provenir de un sitio web donde el Miembro llam&oacute; para obtener la tarifa, o de un correo electr&oacute;nico recibido. Adem&aacute;s, la tarifa debe cotizarse, reservarse y pagarse en d&oacute;lares estadounidenses.</p>
    <p>Todas las solicitudes de Garant&iacute;a de precio, incluidos los recibos, est&aacute;n sujetas a verificaci&oacute;n por parte del Administrador del programa. El Administrador no aceptar&aacute; capturas de pantalla u otra evidencia de un precio m&aacute;s bajo que el personal de <strong>Miles</strong> no pueda confirmar de forma independiente.</p>
        </div>
    </div>
    
</div>
